export const CustomerAgreementsQueryKey = 'customer-agreements';
export const CustomerAgreementQueryKey = 'customer-agreement';
export const CustomerAgreementLanguagesQueryKey = 'customer-agreement-languages';
export const CustomerAgreementAssignmentQueryKey = 'customer-agreement-assignment';
export const CustomerAgreementDeactivationImpactQueryKey = 'customer-agreement-deactivation-impact';
